//region 2. Project Libraries
import { logger } from '../DataAPI';
//endregion

export default function checkRecorderModule(req, res, next) {
        const log = (lvl, msg) => logger.log(lvl, msg, { tags: 'checkPort' });
        const module = req.body.module;
        if (!module) {
                const message = 'No Module';
                log('error', message);
                res.status(400).send(message);
                return;
        }
        if (['broker', 'archive', 'live', 'event'].indexOf(module) === -1) {
                const message = `Invalid Module Name ${module}`;
                log('error', message);
                res.status(400).send(message);
                return;
        }
        next();
}
